import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

// Dışarıdan 'value' (yüzde) ve 'label' (metin) proplarını ekledik
const ApexRadial = ({ dataColors, value = 0, label = "Büyüme" }) => {
  const apexRadialChartColors = getChartColorsArray(dataColors);
  
  // Dışarıdan gelen değeri grafiğe veriyoruz (Eğer gelmezse 0 gösterir)
  const series = [value]; 
  
  const options = {
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: "13px",
            color: undefined,
            offsetY: 60,
          },
          value: {
            offsetY: 22,
            fontSize: "16px",
            color: undefined,
            formatter: function (e) {
              return e + "%";
            },
          },
        },
      },
    },
    colors: apexRadialChartColors,
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 4,
    },
    // Grafiğin altındaki metni dışarıdan gelen label ile değiştiriyoruz
    labels: [label], 
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="200"
      className="apex-charts"
    />
  );
};

export default ApexRadial;